// src/pages/HomeView/components/NewsFeedTab.tsx
import React from 'react';
import { NewsFeedSection } from './NewsFeed/NewsFeedSection';
import { MyCardsSection } from './NewsFeed/MyCardsSection';
import { DueTimelineSection } from './NewsFeed/DueTimelineSection';
import type { DashboardFilter } from '../../../services/homeService';

interface NewsFeedTabProps {
  searchText: string;
  filters: DashboardFilter[];
  extraFilterParams?: Record<string, number>;
  refreshToken?: number;
  viewAsPersonId?: string;
}

export const NewsFeedTab: React.FC<NewsFeedTabProps> = ({
  searchText,
  filters,
  extraFilterParams,
  refreshToken,
  viewAsPersonId,
}) =>
{
  return (
    <div className="newsfeed-tab-content h-full overflow-hidden flex flex-col">
      <div className="newsfeed-columns-grid gap-4 flex-1 p-4 pt-0 overflow-hidden">
        <div className="area-newsfeed h-full overflow-hidden">
          <NewsFeedSection
            searchText={searchText}
            filters={filters}
            extraFilterParams={extraFilterParams}
            refreshToken={refreshToken}
            viewAsPersonId={viewAsPersonId}
          />
        </div>

        <div className="area-rightcol">
          <div className="area-mycards h-full overflow-hidden">
            <MyCardsSection
              searchText={searchText}
              refreshToken={refreshToken}
              viewAsPersonId={viewAsPersonId}
            />
          </div>

          <div className="area-due h-full overflow-hidden">
            <DueTimelineSection
              searchText={searchText}
              refreshToken={refreshToken}
              viewAsPersonId={viewAsPersonId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
